import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";

export default function StopMonitoringDialog({ isOpen, onDismiss, onStop }) {
  const { t } = useTranslation();
  return (
    <Dialog
      zIndex={1500}
      buttons={[
        {
          text: t("buttons.cancel"),
          onClick: onDismiss
        },
        { text: t("buttons.gotIt"), onClick: onStop }
      ]}
      heading={t("purchase.buy.stopMonitoringDialog.heading")}
      text={t("purchase.buy.stopMonitoringDialog.text")}
      isOpen={isOpen}
    />
  );
}
